export const SUBSCRIPTION_STATES = {
  active: 'active',
  canceled: 'canceled',
  expired: 'expired',
  renewal_period: 'renewal_period'
};
